import {
	creators,
	print,
	type Clause,
	type Jast,
	COMPOUND_OPERATOR_AND,
	OPERATOR_IN,
} from '@atlaskit/jql-ast';
import type { CascadingSelectState } from '@atlassian/jira-jql-builder-basic-cascading-select/src/common/types.tsx';
import { CASCADE_OPTION_FUNCTION_NAME } from '../../../../../common/constants.tsx';
import { escapeBackslashes } from '../../../../../common/utils.tsx';

const createTerminalClause = (fieldId: string, value: CascadingSelectState) => {
	const args: Array<string | number> = [];
	if (value.parentOption) {
		// parent value first
		args.push(value.parentOption.value);
	}
	if (value.childOption) {
		// followed by child value
		args.push(value.childOption.value);
	}

	return creators.terminalClause(
		creators.field(escapeBackslashes(fieldId)),
		creators.operator(OPERATOR_IN),
		creators.functionOperand(
			creators.functionString(CASCADE_OPTION_FUNCTION_NAME),
			args.map((argString) => creators.argument(argString.toString())),
		),
	);
};

export const getUpdatedJql = (
	ast: Jast,
	clause: Clause | undefined,
	fieldId: string,
	value: CascadingSelectState,
): string => {
	const hasValue = Boolean(value.parentOption || value.childOption);
	if (!clause) {
		if (!ast.query || !hasValue) {
			return ast.represents;
		}
		ast.query.appendClause(createTerminalClause(fieldId, value), COMPOUND_OPERATOR_AND);
	} else if (!hasValue) {
		clause.remove();
	} else {
		clause.replace(createTerminalClause(fieldId, value));
	}

	return print(ast, {
		operatorCase: 'upper',
	});
};
